import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {AsideMenu} from './AsideMenu'
import {ROOTS_DASHBOARD} from '../../../../app/routing/paths'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {IWorkspaceState} from '../../../../app/@reducer/WorkspaceRedux'

const AsideDefault: FC = () => {

  const {config, classes} = useLayout(),
    {aside} = config

  const {
    images: {logo}
  } = useSelector<RootState>(({workspace}) => workspace, shallowEqual) as IWorkspaceState

  const imgPath = logo ? logo : toAbsoluteUrl('/media/logos/Logo-WF_1.png')


  return (
    <div
      id='kt_aside'
      className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_mobile_toggle'
    >
      {/* begin::Brand */}
      <div className='aside-logo flex-column-auto' id='kt_aside_logo'>
        {/* begin::Logo */}
        <Link to={ROOTS_DASHBOARD} className="h-100 overflow-hidden d-flex justify-content-center align-items-center">
          <img
            alt='Logo'
            className='w-100 logo'
            src={imgPath}
          />
        </Link>
        {/*{aside.theme === 'dark' && (*/}
        {/*  <Link to={ROOTS_DASHBOARD} className="h-25px w-100">*/}
        {/*    <img*/}
        {/*      alt='Logo'*/}
        {/*      className='h-100 w-100 logo'*/}
        {/*      src={imgPath}*/}
        {/*    />*/}
        {/*  </Link>*/}
        {/*)}*/}
        {/*{aside.theme === 'light' && (*/}
        {/*  <Link to={ROOTS_DASHBOARD} className="h-75 overflow-hidden bg-danger">*/}
        {/*    <img*/}
        {/*      alt='Logo'*/}
        {/*      className='w-100 logo'*/}
        {/*      src={imgPath}*/}
        {/*    />*/}
        {/*  </Link>*/}
        {/*)}*/}
        {/* end::Logo */}

        {/* begin::Aside toggler */}
        {aside.minimize && (
          <div
            id='kt_aside_toggle'
            className='btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle'
            data-kt-toggle='true'
            data-kt-toggle-state='active'
            data-kt-toggle-target='body'
            data-kt-toggle-name='aside-minimize'
          >
            <KTSVG
              path={'/media/icons/duotune/arrows/arr080.svg'}
              className={'svg-icon-1 rotate-180'}
            />
          </div>
        )}
        {/* end::Aside toggler */}
      </div>
      {/* end::Brand */}

      {/* begin::Aside menu */}
      <div className='aside-menu flex-column-fluid'>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>
      {/* end::Aside menu */}
    </div>
  )
}

export {AsideDefault}
